import { TrialBalanceResponse } from "@common/types/reports/types";
import { TrialBalanceViewRow } from "./trialBalanceViewTypes";

export function buildTrialBalanceRows(
    report: TrialBalanceResponse,
): TrialBalanceViewRow[] {
    const lastIndex = report.rows.length - 1;
    return report.rows.map((row, index) => ({
        id: `row:${index}:${row.key}`,
        title: row.label,
        values: row.values,
        isSummary: index === lastIndex,
        accountCode: index === lastIndex ? undefined : row.key,
    }));
}
